import { Foundation } from 'foundation-sites/js/foundation.core';
import { Reveal } from 'foundation-sites/js/foundation.reveal';
import { Accordion } from 'foundation-sites/js/foundation.accordion';
import { Equalizer } from 'foundation-sites/js/foundation.equalizer';
import { Interchange } from 'foundation-sites/js/foundation.interchange';
import deBounce from 'lodash.debounce';
import jQuery from 'jquery';

var mediaQuery = require('foundation-sites/js/foundation.util.mediaQuery');
var imageLoader = require('foundation-sites/js/foundation.util.imageLoader');

jQuery(document).ready(function($) {
    Foundation.plugin(Reveal, 'Reveal');
    Foundation.plugin(Equalizer, 'Equalizer');
    Foundation.plugin(Accordion, 'Accordion');
    Foundation.plugin(mediaQuery, 'mediaQuery');
    Foundation.plugin(imageLoader, 'imageLoader');
    Foundation.plugin(Interchange, 'Interchange');

    Foundation.addToJquery(jQuery);
    $(document).foundation();

    $(window).on('changed.zf.mediaquery resize', deBounce(() => {
        if ($('[data-equalizer]').length) {
            Foundation.reInit('Equalizer');
        }
    }, 100));

    // make equalizer run again after Interchange or other lazy-load solution runs
    // TODO: probably a more efficient way to do this
    $('[data-equalizer] img').on('load', function () {
        Foundation.reInit('Equalizer');
    });

    // if(Foundation.mediaQuery.MediaQuery.current == 'medium') {
    //     var outerContent = $('.scroll');
    //     var innerContent = $('.module--cta-scroller');
    //     outerContent.scrollLeft((innerContent.width() - outerContent.width()) / 2);
    // } else if(Foundation.mediaQuery.MediaQuery.current == 'large') {
    //     var outerContent = $('.scroll');
    //     var innerContent = $('.module--cta-scroller');
    //     outerContent.scrollLeft((innerContent.width() - outerContent.width()) / 2);
    // } else {
    //     outerContent.scrollLeft(0);
    // }

})